import React from 'react';
import { RefObjectToMutableRefObject } from './RefObjectToMutableRefObject';
import { AggregatableRef } from './types';

/**
 * Combines multiple refs into a single aggregated ref to be supplied to an
 * element.
 *
 * Prefer `useAggregatedRef` over this function where possible. This function is
 * intended to be used in contexts where hooks are not allowed, such as inside
 * render functions that supply a `ref` as a parameter.
 */
export const aggregateRefs =
  <T extends unknown>(refs: AggregatableRef<T>[]): React.RefCallback<T> =>
  (instance: T) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(instance);
      } else if (ref && 'current' in ref) {
        // eslint-disable-next-line no-param-reassign
        (ref as RefObjectToMutableRefObject<typeof ref>).current = instance;
      }
    });
  };
